import { lazy, Suspense } from 'react';

import { ListSkeleton, TextSkeleton } from '@/shared/components/skeletons';

/*
 * Components the module contributes to other pages (group tab, side panel), loaded on first use so the reader, the
 * tree and their dependencies stay out of the main bundle.
 */
const GroupWikiTabLazy = lazy(async () => ({
  default: (await import('./components/GroupWikiTab')).GroupWikiTab,
}));
const WikiPagePanelLazy = lazy(async () => ({
  default: (await import('./components/WikiPagePanel')).WikiPagePanel,
}));

export function GroupWikiTabEntry({ groupId }: { groupId: string }) {
  return (
    <Suspense fallback={<ListSkeleton rows={6} />}>
      <GroupWikiTabLazy groupId={groupId} />
    </Suspense>
  );
}

export function WikiPagePanelEntry({ id }: { id: string }) {
  return (
    <Suspense fallback={<TextSkeleton lines={8} className="p-6" />}>
      <WikiPagePanelLazy id={id} />
    </Suspense>
  );
}
